import { store } from "@/store/store";
import { DatosEmpresa } from "@/shared/dtos/datos_empresa";
import { document_fileDto } from "@/shared/dtos/document_fileDto";
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action,
} from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({
    namespaced: true,
    name: "datos_empresaModule",
    store,
    dynamic: true,
})
class DatosEmpresaModule extends VuexModule {
    public datos_empresas: DatosEmpresa[] = [];
    public datos_empresa: DatosEmpresa = new DatosEmpresa();
    public documentos: document_fileDto[] = [];

    @Action({ commit: "onGetDatosEmpresas" })
    public async getDatosEmpresas() {
        return await ssmHttpService.get(API.datos_empresa);
    }

    @Action({ commit: "onGetDatosEmpresa" })
    public async getDatosEmpresa(id: any) {
        return await ssmHttpService.get(API.datos_empresa + "/" + id);
    }

    @Action
    public async guardarDatosEmpresa(datos_empresa: DatosEmpresa) {
        await ssmHttpService.post(API.datos_empresa, datos_empresa.toJson());
        await this.getDatosEmpresas();
    }

    @Action
    public async modificarDatosEmpresa(datos_empresa: DatosEmpresa) {
        await ssmHttpService.put(
            API.datos_empresa + "/" + datos_empresa.id,
            datos_empresa
        );
        await this.getDatosEmpresas();
    }

    @Action
    public async eliminarDatosEmpresa(datos_empresa: DatosEmpresa) {
        await ssmHttpService.delete(
            API.datos_empresa + "/" + datos_empresa.id,
            null,
            false
        );
        await this.getDatosEmpresas();
    }

    // --- GESTIÓN DE DOCUMENTOS ---

    @Action({ commit: "onGetDocuments" })
    public async getDocuments(id: any) {
        return await ssmHttpService.get(API.datos_empresa + "/documents/" + id);
    }

    @Action
    public async subirDocumento(payload: { id: any; files: FormData }) {
        const res = await ssmHttpService.postfile(
            API.datos_empresa + "/documents/" + payload.id,
            payload.files
        );
        await this.getDocuments(payload.id);
        return res;
    }

    @Action
    public async eliminarDocumento(payload: { id: any; file: document_fileDto }) {
        await ssmHttpService.put(
            API.datos_empresa + "/documents/" + payload.id,
            payload.file
        );
        await this.getDocuments(payload.id);
    }

    @Mutation
    public onGetDatosEmpresas(res: DatosEmpresa[]) {
        this.datos_empresas = res ? res.map((x) => new DatosEmpresa(x)) : [];
        try {
            this.datos_empresa = this.datos_empresas[0];
        } catch (error) { }
    }

    @Mutation
    public onGetDatosEmpresa(res: DatosEmpresa) {
        this.datos_empresa = res;
    }

    @Mutation
    public onGetDocuments(res: document_fileDto[]) {
        this.documentos = res ? res.map((x) => new document_fileDto(x)) : [];
    }
}

export default getModule(DatosEmpresaModule);
